// @flow
const GET_USERS = 'admin/users/GET_USERS';
const GET_USERS_FAIL = 'admin/users/GET_USERS_FAIL';
const GET_USERS_SUCCESS = 'admin/users/GET_USERS_SUCCESS';

const UPDATE_USER = 'admin/users/UPDATE_USER';
const UPDATE_USER_FAIL = 'admin/users/UPDATE_USER_FAIL';
const UPDATE_USER_SUCCESS = 'admin/users/UPDATE_USER_SUCCESS';

const CREATE_USER = 'admin/users/CREATE_USER';
const CREATE_USER_FAIL = 'admin/users/CREATE_USER_FAIL';
const CREATE_USER_SUCCESS = 'admin/users/CREATE_USER_SUCCESS';

const DELETE_USERS = 'admin/users/DELETE_USERS';
const DELETE_USERS_FAIL = 'admin/users/DELETE_USERS_FAIL';
const DELETE_USERS_SUCCESS = 'admin/users/DELETE_USERS_SUCCESS';

export {
  CREATE_USER,
  CREATE_USER_FAIL,
  CREATE_USER_SUCCESS,
  DELETE_USERS,
  DELETE_USERS_FAIL,
  DELETE_USERS_SUCCESS,
  GET_USERS,
  GET_USERS_FAIL,
  GET_USERS_SUCCESS,
  UPDATE_USER,
  UPDATE_USER_FAIL,
  UPDATE_USER_SUCCESS,
};

export type User = {|
  addUserToAllCatalogs?: boolean,
  createdBy?: string,
  creationDate?: string,
  email?: string,
  fromLDAP?: boolean,
  identSvcUuid?: string,
  isToken?: boolean,
  lastModifiedDate?: string,
  ldapSourceDN?: string,
  longName?: string,
  modifiedBy?: string,
  name: string,
  notes?: string,
  password?: string,
  roleName?: string, // Used for Catalog Users page
  token?: string,
  userStatus?: 'online' | 'offline', // Used for Catalog Users page
  uuid?: string,
|};

export type CleanupToken =
  | 'make private galleries public'
  | 'delete private galleries';

type GetUsersAction = {|
  type: 'admin/users/GET_USERS',
  payload: { session: string },
|};

type GetUsersFailAction = {|
  type: 'admin/users/GET_USERS_FAIL',
|};

type GetUsersSuccessAction = {|
  type: 'admin/users/GET_USERS_SUCCESS',
  payload: User[],
|};

type UpdateUserAction = {|
  type: 'admin/users/UPDATE_USER',
  payload: { session: string },
|};

type UpdateUserFailAction = {| type: 'admin/users/UPDATE_USER_FAIL' |};

type UpdateUserSuccessAction = {|
  type: 'admin/users/UPDATE_USER_SUCCESS',
  payload: User[],
|};

type CreateUserAction = {|
  type: 'admin/users/CREATE_USER',
|};

type CreateUserFailAction = {|
  type: 'admin/users/CREATE_USER_FAIL',
|};

type CreateUserSuccessAction = {|
  type: 'admin/users/CREATE_USER_SUCCESS',
|};

type DeleteUsersAction = {|
  type: 'admin/users/DELETE_USERS',
|};

type DeleteUsersFailAction = {|
  type: 'admin/users/DELETE_USERS_FAIL',
|};

type DeleteUsersSuccessAction = {|
  type: 'admin/users/DELETE_USERS_SUCCESS',
|};

export type Action =
  | CreateUserAction
  | CreateUserFailAction
  | CreateUserSuccessAction
  | DeleteUsersAction
  | DeleteUsersFailAction
  | DeleteUsersSuccessAction
  | GetUsersAction
  | GetUsersFailAction
  | GetUsersSuccessAction
  | UpdateUserAction
  | UpdateUserFailAction
  | UpdateUserSuccessAction;

export type UserState = {
  users: User[],
};



// WEBPACK FOOTER //
// ./src/state/types/userTypes.js